import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/pos-api";

export const VPS_BILLING_UPDATED = "pos-vps-billing-updated";
export const formatVpsDate = value => value ? new Date(`${value}T12:00:00+07:00`).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Jakarta" }) : "Belum diatur";

export default function VpsExpiryNotice() {
  const [settings, setSettings] = useState(null);
  const [stale, setStale] = useState(false);
  useEffect(() => {
    let controller, timer, stopped = false;
    async function load() {
      clearTimeout(timer); controller?.abort();
      const request = new AbortController(); controller = request;
      try {
        const { data } = await api.get("/master/system/vps-billing", { signal: request.signal, timeout: 10000 });
        if (!stopped && !request.signal.aborted) { setSettings(data); setStale(false); }
      } catch (e) { if (!stopped && !request.signal.aborted) setStale(true); }
      finally { if (!stopped && !request.signal.aborted) timer = setTimeout(load, 5 * 60 * 1000); }
    }
    function updated(event) {
      controller?.abort(); clearTimeout(timer);
      setSettings(event.detail); setStale(false);
      timer = setTimeout(load, 5 * 60 * 1000);
    }
    function visible() { if (document.visibilityState === "visible") load(); }
    load();
    window.addEventListener(VPS_BILLING_UPDATED, updated);
    window.addEventListener("focus", load);
    document.addEventListener("visibilitychange", visible);
    return () => {
      stopped = true; controller?.abort(); clearTimeout(timer);
      window.removeEventListener(VPS_BILLING_UPDATED, updated);
      window.removeEventListener("focus", load);
      document.removeEventListener("visibilitychange", visible);
    };
  }, []);
  const days = settings?.days_remaining;
  if (days == null || days > 30) return null;
  const timing = days < 0 ? `Lewat jatuh tempo ${Math.abs(days)} hari` : days === 0 ? "Jatuh tempo hari ini" : `Jatuh tempo ${days} hari lagi`;
  return <aside role="status" aria-label="Pengingat jatuh tempo VPS" className={`shrink-0 mx-3 my-2 rounded-xl border px-4 py-3 flex flex-wrap items-center justify-between gap-2 ${days <= 0 ? "border-danger bg-danger-soft text-danger-readable" : "border-warning bg-warning-soft text-warning-readable"}`}>
    <div className="min-w-0"><p className="text-sm font-bold">VPS Neo · {timing}</p><p className="text-xs">{formatVpsDate(settings.next_due_date)} · Tanggal dicatat manual. Periksa pembayaran/perpanjangan di Neo.</p>{stale && <p className="text-xs">Pengingat memakai data terakhir; pembaruan belum berhasil.</p>}</div>
    <Link to="/master/system" className="shrink-0 text-sm font-semibold underline">Atur tanggal VPS</Link>
  </aside>;
}
